import type { SVGProps } from 'react';
export const ShoppingBag = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M4.35 5.33v9.34h11.3V5.33zM3 5.2C3 4.56 3.52 4 4.2 4h11.6c.68 0 1.2.56 1.2 1.2v9.6c0 .64-.52 1.2-1.2 1.2H4.2A1.2 1.2 0 0 1 3 14.8zm4.29 1.47c.37 0 .68.3.68.66 0 .53.21 1.04.6 1.42a2.05 2.05 0 0 0 2.87 0c.38-.38.6-.89.6-1.42 0-.36.3-.66.67-.66s.68.3.68.66a3.3 3.3 0 0 1-1 2.36 3.4 3.4 0 0 1-4.79 0 3.3 3.3 0 0 1-.99-2.36c0-.36.3-.66.68-.66"
      clipRule="evenodd"
    />
  </svg>
);
